import classNames from "classnames";

export const wrapper = classNames("w-full", "pt-10", "pb-10", "bg-secondary");
export const blogs = classNames("overflow-hidden", "mt-10", "text-white", "flex", "items-center", "justify-center");
